import type { MealSlot } from '@st/contract';

/**
 * Termin obroka je enum na API-ju (`slot`), a ne slobodan naziv. Prijevodni
 * ključevi žive ovdje da ih dnevnik prehrane i unos obroka ne mapiraju svaki
 * na svoj način.
 */
export const MEAL_SLOT_KEY: Record<MealSlot, string> = {
  breakfast: 'nutrition.slotBreakfast',
  lunch: 'nutrition.slotLunch',
  dinner: 'nutrition.slotDinner',
  snack: 'nutrition.slotSnack',
};
